




















































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import CareerDetails from '@/components/CareerDetails.vue';
import ApplicationForm from '@/components/ApplicationForm.vue';
import axios from 'axios';
import { API_URL } from '../global';

const DEFAULT_FORM_DATA = {
  full_name: '',
  email: '',
  phone: '',
  linkedin_url: '',
  cv: null,
  job: null
};

@Component({
  name: 'JobDetailsPage',
  components: {
    ValidationProvider,
    ValidationObserver,
    single_title: CareerDetails,
    apply_form: ApplicationForm
  }
})
export default class JobDetailsPage extends Vue {
  @Prop() pageData: any;
  jobForm: any = JSON.parse(JSON.stringify(DEFAULT_FORM_DATA));
  submitted = false;
  submitSuccess = false;

  onSubmit() {
    (this as any).$refs.form.validate().then((valid: any) => {
      const data = JSON.parse(JSON.stringify(this.jobForm));
      data.job = this.pageData.id;
      const formData = new FormData();
      if ((this as any).$refs.cv.files.length) {
        Object.keys(data).map((key: string) => {
          if (['cv'].indexOf(key) == -1) {
            formData.append(key, data[key]);
          }
        });
        formData.append('cv', (this.$refs.cv as any).files[0]);
        axios
          .post(`${API_URL}/job-apply/`, formData)
          .then((resp: any) => {
            this.submitted = true;
            this.submitSuccess = true;
          })
          .catch((err: any) => {
            this.submitted = true;
          });
      }
    });
  }
}
